// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.budget-list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.budget-list .b-list-item {
  width: 20%;
  padding: 10px 13px;
  font-size: 13px;
}
.budget-list .b-list-item span {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/grants/grants-application-ext/grants-budget/grants-budget.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,eAAA;EACA,WAAA;AACJ;AAAI;EACI,UAAA;EACA,kBAAA;EACA,eAAA;AAER;AADQ;EACI,cAAA;AAGZ","sourcesContent":[".budget-list {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    width: 100%;\r\n    .b-list-item {\r\n        width: 20%;\r\n        padding: 10px 13px;\r\n        font-size: 13px;\r\n        span {\r\n            display: block;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
